(function () {
  function initSection(root) {
    const slider = root.querySelector('[id^="Slider-"]');
    const progressFill = root.querySelector('[data-pv-bestsellers-progress]');
    if (slider && progressFill) {
      const updateProgress = () => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 0) {
          progressFill.style.width = '100%';
          progressFill.style.left = '0';
          return;
        }
        const ratio = slider.scrollLeft / maxScroll;
        const slideCount = root.querySelectorAll('[id^="Slide-"]').length || 4;
        const thumb = Math.max(0.12, 1 / slideCount);
        const widthPct = thumb * 100;
        const leftPct = ratio * (100 - widthPct);
        progressFill.style.width = `${widthPct}%`;
        progressFill.style.left = `${leftPct}%`;
      };
      slider.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    root.querySelectorAll('[data-pv-ord-card]').forEach((card) => {
      const priceEl = card.querySelector('[data-pv-ord-price]');
      const variantInput = card.querySelector('[data-pv-ord-variant-input]');
      const atcBtn = card.querySelector('[data-pv-ord-atc]');
      const atcLabel = card.querySelector('[data-pv-ord-atc-label]');
      const sizeButtons = card.querySelectorAll('[data-pv-ord-size]');
      if (!sizeButtons.length) return;

      sizeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          if (typeof window.pvOrdApplyVariantSelection === 'function') {
            window.pvOrdApplyVariantSelection(card, btn);
            return;
          }
          sizeButtons.forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          if (variantInput) variantInput.value = btn.dataset.variantId;
          if (btn.dataset.variantPrice && priceEl) {
            priceEl.textContent = btn.dataset.variantPrice;
          }
          if (atcBtn && atcLabel) {
            const available = btn.dataset.variantAvailable === 'true';
            atcBtn.disabled = !available;
            atcLabel.textContent = available ? 'add to cart' : 'Sold out';
          }
        });
      });
    });
  }

  document.querySelectorAll('.pv-bestsellers').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.pv-bestsellers') || event.target.closest('.pv-bestsellers');
    if (section) initSection(section);
  });
})();
